import { LineupsService } from '@games/infra';
import { inject } from '@angular/core';
import { map, Observable, switchMap, take } from 'rxjs';
import { ActivatedRoute, Params } from '@angular/router';
import { UpdateGameLineupsBody, UpdateGameLineupsPathParams } from '@core-http';

export class SaveLineupsCommandHandler {
  private readonly lineupsService: LineupsService = inject(LineupsService);
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  save(players: string[]): Observable<void> {
    return this.activatedRoute.params.pipe(
      take(1),
      switchMap((params: Params) => {
        const gameId: string = params['id'];
        const pathParams: UpdateGameLineupsPathParams = { gameId };
        const body: UpdateGameLineupsBody = this.mapToDto(players);

        return this.lineupsService.save(pathParams, body).pipe(map(() => void 0));
      })
    );
  }

  private mapToDto(players: string[]): UpdateGameLineupsBody {
    const teamSize: number = this.calculateTeamSize(players.length);
    const teamAlpha: string[] = players.slice(0, teamSize);
    const teamBeta: string[] = players.slice(teamSize);

    return {
      lineups: [
        { lineupPlayers: teamAlpha.map((playerId: string) => ({ playerId })) },
        { lineupPlayers: teamBeta.map((playerId: string) => ({ playerId })) }
      ]
    };
  }

  private calculateTeamSize(length: number): number {
    if (!length) return 0;
    return Math.round(length / 2);
  }
}
